import IdleTimerDialog from './IdleTimerDialog';
export default IdleTimerDialog;